<template>
  <div
    ref="rootEl"
    class="order-facet-fi"
  >
    <template v-if="facet.type === 'search'">
      <search-facet-fi
        :facet
        @change="onChange"
      />
    </template>

    <select-fi
      v-else
      :elements="facet.elements"
      :name="facet.name"
      :multiselect="facet.multiselect"
      :disabled="facet.disabled"
      :open="open"
      large
      @change="onChange"
      @toggle-open="onToggleOpen()"
      @close="onClose()"
    />
  </div>
</template>

<script setup lang="ts">
import { SelectFi } from 'atoms';
import { onMounted, useTemplateRef, watch } from 'vue';

import type { GenericFacet, GenericFacetChange } from '@/components/facets/facet-types';
import SearchFacetFi from '@/components/facets/search-facet-fi/SearchFacetFi.vue';

defineOptions({ name: 'DocumentDownloadFacetFi' });

const props = withDefaults(
  defineProps<{
    facet: GenericFacet;
    open?: boolean;
    idx?: number | null;
    registerDomElement?: ((el: Element) => void) | null;
  }>(),
  {
    open: false,
    idx: null,
    registerDomElement: null,
  },
);

const emit = defineEmits<{
  change: [value: GenericFacetChange];
  close: [];
  'toggle-open': [];
}>();

const rootEl = useTemplateRef<HTMLElement>('rootEl');

const registerElement = (idx: number | null) => {
  if (idx === 0 && props.registerDomElement && rootEl.value) {
    props.registerDomElement(rootEl.value);
  }
};

onMounted(() => {
  registerElement(props.idx);
});

watch(
  () => props.idx,
  (newValue) => {
    registerElement(newValue);
  },
);

const onClose = () => {
  if (props.open) {
    onToggleOpen();
  }
  emit('close');
};

const onToggleOpen = () => {
  emit('toggle-open');
};

const onChange = (value: GenericFacetChange) => {
  emit('change', value);
};
</script>
